export const pmsVesselSystemAssignmentDescriptionPatternInformation = `Depending on the value of pms_vessel_system_assignment_description_pattern,
have the below:

1.  vessel_system_description_and_assignment_identifier
     a. System
           i. Set the base description:
              <System Description>
          ii. If the system assignment has an assignment identifier, append:
              - <Assignment Identifier>
         iii. If the system is assigned many times to the (same) vessel and the
              assignment identifier does not exist append:
              - <System Index>
     b. Subsystem
           i. Set the system description as per the above convention, then append:
              - <Subsystem Description>
          ii. If the subsystem assignment has an assignment identifier, append:
              - <Assignment Identifier>
         iii. If the subsystem has multiplicity > 1 and the assignment identifier does
              not exist append:
              - <Subsystem Index>
2.  vessel_system_assignment_group
     a. System
           i. If <Vessel System Assignment Group> is not null then:
              <Vessel System Assignment Group>
          ii. Else use the pattern mentioned in point 1
     b. Subsystem
           i. Set the system description as per the above convention, then append:
              - <Subsystem Description>
          ii. If the subsystem assignment has an assignment identifier, append:
              - <Assignment Identifier>
         iii. If the subsystem has multiplicity > 1 and the assignment identifier does
              not exist append:
              - <Subsystem Index>`;

export const pmsDefaultJobStatusProgressOptions = [
  {
    label: 'TODO - Edit from the Office',
    value: {
      progress: 'not_started',
      edit_side: 'office'
    }
  },
  {
    label: 'TODO - Edit Onboard',
    value: {
      progress: 'not_started',
      edit_side: 'vessel'
    }
  }
] as const;
